import { useLayoutEffect, useState } from 'react';

// Reports an element's rendered height so callers can park sticky content directly below
// it. Measured rather than hardcoded because toolbar heights shift with font metrics and
// with scrollbars that only take up layout space on some platforms. The returned ref is a
// callback ref so the measurement also runs for elements that mount later.
const useElementHeight = () => {
  const [element, setElement] = useState(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (!element) return undefined;

    const measure = () => setHeight(element.offsetHeight);
    measure();

    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);

  return { ref: setElement, height };
};

export default useElementHeight;
